import PatientDataSummaryStatement from "./PatientDataSummaryStatement";
export default PatientDataSummaryStatement;
